import service from "@/utils/request";

// 上课教室选择列表
export interface classroomSelectListDataInter {
  page: number;
  page_size: number;
  name?: string;
}
export const classroomSelectListApi = (
  params: classroomSelectListDataInter
) => {
  return service({
    url: "/api/v1/classroom/select_list",
    method: "get",
    params,
  });
};

// 教室列表
export interface classroomListInter {
  page: number;
  page_size: number;
  sort_field?: string;
  sort_type?: string;
  name?: string;
}
export const classroomListApi = (params: classroomListInter) => {
  return service({
    url: "/api/v1/classroom/list",
    method: "get",
    params,
  });
};

// 教室删除
export const classroomDelApi = (data: { classroom_id: number }) => {
  return service({
    url: "/api/v1/classroom/del",
    method: "post",
    data,
  });
};

// 教室添加
export interface classroomAddInter {
  name: string;
  people: number;
  remark?: string;
}
export const classroomAddApi = (data: classroomAddInter) => {
  return service({
    url: "/api/v1/classroom/add",
    method: "post",
    data,
  });
};

// 教室编辑
export interface classroomEditInter {
  name: string;
  people?: number;
  remark?: string;
  classroom_id: number;
}
export const classroomEditApi = (data: classroomEditInter) => {
  return service({
    url: "/api/v1/classroom/edit",
    method: "post",
    data,
  });
};
